export const externalLink = (externalUrl) => {
	window.open(externalUrl, '_blank');
};
